'use client';

import { MobileAndTabletAccountHealth } from 'src/components/GridSections/AccountHealth/AccountHealth';
import React from 'react';
import ContentGuard from 'src/components/ContentGuard';

const verticalBreakpoint = 1000;

const MarginInfo = () => {
	return (
		<ContentGuard requireWallet>
			<div className="relative thin-scroll h-full overflow-auto rounded-sm bg-main-bg py-md">
				<div className="h-full">
					<MobileAndTabletAccountHealth />
				</div>
			</div>
		</ContentGuard>
	);
};

MarginInfo.verticalBreakpoint = verticalBreakpoint;
export default React.memo(MarginInfo);
